import {localCommand} from "../utils/api";

export const ADD_GLOBAL_SKILL = 'ADD_GLOBAL_SKILL';
export const GLOBAL_SKILL_ADDED = 'GLOBAL_SKILL_ADDED';
export const ADD_GLOBAL_SKILL_FAILED = 'ADD_GLOBAL_SKILL_FAILED';
export const addGlobalSkill = localCommand('v1/globalSkill/AddGlobalSkill', ADD_GLOBAL_SKILL, GLOBAL_SKILL_ADDED,
  ADD_GLOBAL_SKILL_FAILED);